var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddOffer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_628_96",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#2E6900"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_628_96)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_628_96",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#2E6900"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_628_96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8421 13.5053C12.45 13.5053 12.9704 13.2849 13.4033 12.8441C13.8362 12.4033 14.0526 11.8734 14.0526 11.2544C14.0526 10.6354 13.8362 10.1055 13.4033 9.66471C12.9704 9.22392 12.45 9.00352 11.8421 9.00352C11.2342 9.00352 10.7138 9.22392 10.2809 9.66471C9.84803 10.1055 9.63158 10.6354 9.63158 11.2544C9.63158 11.8734 9.84803 12.4033 10.2809 12.8441C10.7138 13.2849 11.2342 13.5053 11.8421 13.5053ZM11.8421 2.25088C12.2105 2.25088 12.5789 2.27433 12.9474 2.32122C13.3158 2.36811 13.6842 2.43845 14.0526 2.53224V4.50176C14.0526 5.12075 14.2691 5.65064 14.702 6.09144C15.1349 6.53224 15.6553 6.75264 16.2632 6.75264H17.3684V7.87808C17.3684 8.49707 17.5849 9.02696 18.0178 9.46776C18.4507 9.90856 18.9711 10.129 19.5789 10.129H20.6013C20.6382 10.3353 20.6612 10.5557 20.6704 10.7902C20.6796 11.0246 20.6842 11.2544 20.6842 11.4795C20.6842 12.7175 20.4033 13.9461 19.8414 15.1653C19.2796 16.3845 18.6072 17.5287 17.8243 18.5979C17.0414 19.6671 16.2309 20.619 15.3928 21.4537C14.5546 22.2884 13.8592 22.9496 13.3066 23.4373C13.1039 23.6249 12.8737 23.7655 12.6158 23.8593C12.3579 23.9531 12.1 24 11.8421 24C11.5842 24 11.3263 23.9531 11.0684 23.8593C10.8105 23.7655 10.5803 23.6249 10.3776 23.4373C9.18026 22.3118 8.12105 21.2145 7.2 20.1454C6.27895 19.0762 5.50987 18.0399 4.89276 17.0363C4.27566 16.0328 3.80592 15.0668 3.48355 14.1383C3.16118 13.2098 3 12.3236 3 11.4795C3 8.66588 3.88882 6.42438 5.66645 4.75498C7.44408 3.08558 9.50263 2.25088 11.8421 2.25088ZM18.4737 5.6272H16.2632C15.95 5.6272 15.6875 5.51934 15.4757 5.30363C15.2638 5.08792 15.1579 4.82063 15.1579 4.50176C15.1579 4.18288 15.2638 3.91559 15.4757 3.69988C15.6875 3.48417 15.95 3.37632 16.2632 3.37632H18.4737V1.12544C18.4737 0.806565 18.5796 0.539273 18.7914 0.323564C19.0033 0.107855 19.2658 0 19.5789 0C19.8921 0 20.1546 0.107855 20.3664 0.323564C20.5783 0.539273 20.6842 0.806565 20.6842 1.12544V3.37632H22.8947C23.2079 3.37632 23.4704 3.48417 23.6822 3.69988C23.8941 3.91559 24 4.18288 24 4.50176C24 4.82063 23.8941 5.08792 23.6822 5.30363C23.4704 5.51934 23.2079 5.6272 22.8947 5.6272H20.6842V7.87808C20.6842 8.19695 20.5783 8.46424 20.3664 8.67995C20.1546 8.89566 19.8921 9.00352 19.5789 9.00352C19.2658 9.00352 19.0033 8.89566 18.7914 8.67995C18.5796 8.46424 18.4737 8.19695 18.4737 7.87808V5.6272Z",
    fill: "#2E6900"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddOffer);
export default __webpack_public_path__ + "static/media/addOffer.5674e15a09c0f1ee02a3acf2b3764329.svg";
export { ForwardRef as ReactComponent };